module.exports = __webpack_public_path__ + "static/media/case3.fa5519e4.png";